import React from 'react';
import {
  QuestionIcon,
  CheckIcon,
  DownloadIcon,
  ViewIcon,
  UploadIcon
} from '@chakra-ui/icons';
import {
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Box,
  Text,
  List,
  ListItem,
  ListIcon,
  Flex
} from '@chakra-ui/react';

const HelpIconWithTooltip = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Tooltip 
        label="Click for help on creating assessments" 
        placement="top"
      >
        <QuestionIcon 
          color="blue.500" 
          boxSize={5} 
          cursor="pointer" 
          ml={3}
          onClick={onOpen}
        />
      </Tooltip>

      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Assessment Creation Guide</ModalHeader>
          <ModalBody>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={ViewIcon} color="blue.500" />
                <Text as="span" fontWeight="bold">Generate Questions:</Text> Use our question generator to create assessment questions
              </ListItem>
              
              <ListItem>
                <ListIcon as={DownloadIcon} color="blue.500" />
                <Text as="span" fontWeight="bold">Use Template:</Text> Download and fill our CSV template with your questions
              </ListItem>
              
              <ListItem>
                <ListIcon as={ViewIcon} color="blue.500" />
                <Text as="span" fontWeight="bold">Select Existing:</Text> Choose from previously created assessments
              </ListItem>
              
              <ListItem>
                <ListIcon as={UploadIcon} color="blue.500" />
                <Text as="span" fontWeight="bold">Upload & Configure:</Text> Upload files and set assessment parameters
              </ListItem>
            </List>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" size="sm" onClick={onClose}>
              Got it
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default HelpIconWithTooltip;